"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _menu = _interopRequireDefault(require("../utils/menu"));

var ModifierSetSelection = function ModifierSetSelection(_ref) {
  var id = _ref.id,
      name = _ref.name,
      allModifiers = _ref.allModifiers,
      modifierSets = _ref.modifierSets,
      onSelectModifier = _ref.onSelectModifier,
      isModifierSelected = _ref.isModifierSelected,
      isModifierDisabled = _ref.isModifierDisabled,
      checkoutDisabled = _ref.checkoutDisabled,
      _ref$showDivider = _ref.showDivider,
      showDivider = _ref$showDivider === void 0 ? true : _ref$showDivider;

  var modifierSet = _menu["default"].getModifierSetById(modifierSets, id);

  var modifierSetModifierIds = modifierSet.modifiers;

  var modifierSetModifiers = _menu["default"].getModifierSetModifiers(modifierSetModifierIds, allModifiers);

  var min_allowed = modifierSet.min_allowed,
      max_allowed = modifierSet.max_allowed;
  return modifierSetModifiers.length > 0 && _react["default"].createElement("div", {
    className: "item-cart-modifier-set-selection"
  }, showDivider && _react["default"].createElement(_semanticUiReact.Divider, null), _react["default"].createElement("div", {
    className: "modifier-set-selection-header"
  }, _react["default"].createElement("h5", null, name.toUpperCase()), min_allowed > 0 ? _react["default"].createElement(_semanticUiReact.Label, {
    color: "blue"
  }, "REQUIRED") : _react["default"].createElement(_semanticUiReact.Label, {
    color: "blue"
  }, "OPTIONAL")), _react["default"].createElement("div", {
    className: "modifier-set-selection-description"
  }, getModifierSelectionText(min_allowed, max_allowed)), _react["default"].createElement(_semanticUiReact.Form, null, modifierSetModifiers.map(function (modifier, index) {
    var id = modifier.id,
        name = modifier.name,
        price = modifier.price;
    return _react["default"].createElement("div", {
      className: "modifier-set-selection-checkbox",
      key: name
    }, _react["default"].createElement(_semanticUiReact.Form.Field, null, _react["default"].createElement(_semanticUiReact.Checkbox, {
      label: name,
      name: "modifier",
      checked: isModifierSelected(id),
      onChange: function onChange() {
        return onSelectModifier(modifier, modifierSet);
      },
      disabled: checkoutDisabled || isModifierDisabled(modifierSet, id)
    })), _react["default"].createElement("div", null, price && price !== 0 ? "$".concat(price.toFixed(2)) : '-'));
  })));
};

function getModifierSelectionText(min, max) {
  if (min === 0 && max === 0) return 'Select any';
  if (min > 0 && max === 0) return "Select a minimum of ".concat(min);

  if (min > 0 && max > 0) {
    if (min === max) return "Select ".concat(min);
    return "Select ".concat(min, " to ").concat(max);
  }

  return '';
}

var _default = ModifierSetSelection;
exports["default"] = _default;